module.exports = __webpack_public_path__ + "img/chr_ts_90_11.947d91a6.png";